export default __webpack_public_path__ + "static/guaranteed-572ec8682ec79531327614d51a3f1fcc.png";